import { put, call, select } from 'redux-saga/effects'
import I from 'immutable'
import Api from 'domain/api'
import * as Actions from './actions'
import * as M from 'domain/env'
import * as Router from 'domain/router'
import { error403, pageIsLoading } from 'domain/loading'

export interface PostAssocSkillType {
  tagId: number
  associatedTagIds: number[]
}

export interface DeleteAssocSkillItemType {
  tagId?: number
  associatedTagId: number
}

export function* ensureGetAssocSkillsList() {
  try {
    const userToken = yield select(M.userToken)
    if (!userToken) return

    const {
      data: { data }
    } = yield call(Api.getAssocSkillsList, {
      headers: { Authorization: `Bearer ${userToken}` }
    })
    yield put({ type: Actions.assocSkillsList.success, payload: I.fromJS(data) })
  } catch (err) {
    yield put({
      type: Actions.assocSkillsList.failure,
      err
    })
  }
}

export function* ensureGetAssocSkillData() {
  yield put({ type: error403, payload: false })
  const headers = yield select(M.userToken)
  if (!headers) return
  const {
    path,
    params: { id }
  } = yield select(Router.matchRoutes)
  if (id === 'new') {
    yield put({ type: Actions.assocSkillData.success, payload: I.fromJS({}) })
    return
  }
  try {
    yield put({ type: pageIsLoading, payload: true })
    const {
      data: { data }
    } = yield call(Api.getAssocSkillData, {
      headers: { Authorization: `Bearer ${headers}` },
      id
    })
    yield put({ type: Actions.assocSkillData.success, payload: I.fromJS(data) })
  } catch (err) {
    yield put({ type: Actions.assocSkillData.success, payload: I.fromJS({}) })
    const { statusCode } = err.response.data
    if (statusCode === 403 || statusCode === 404) {
      yield put({ type: error403, payload: true })
    }
    yield put({
      type: Actions.assocSkillData.failure,
      err
    })
  } finally {
    yield put({ type: pageIsLoading, payload: false })
  }
}

export function* ensurePostAssocSkill({ payload }: { payload: PostAssocSkillType; type: string }) {
  const headers = yield select(M.userToken)
  if (!headers) return
  try {
    const {
      data: { data }
    } = yield call(Api.postAssocSkillData, {
      headers: { Authorization: `Bearer ${headers}` },
      data: payload
    })
    yield put({ type: Actions.postAssocSkillData.SUCCESS, payload: I.fromJS(data) })
  } catch (err) {
    yield put({
      type: Actions.postAssocSkillData.FAILURE,
      err
    })
  }
}

export function* ensureDeleteAssocSkillItem({
  payload
}: {
  payload: DeleteAssocSkillItemType
  type: string
}) {
  const headers = yield select(M.userToken)
  if (!headers) return
  yield put({ type: pageIsLoading, payload: true })
  const {
    params: { id }
  } = yield select(Router.matchRoutes)
  const { tagId, associatedTagId } = payload
  try {
    const {
      data: { data }
    } = yield call(Api.deleteAssocSkillItem, {
      headers: { Authorization: `Bearer ${headers}` },
      tagId: tagId || id,
      associatedTagId
    })
    yield put({ type: Actions.deleteAssocSkillItem.SUCCESS, payload: I.fromJS(data) })
  } catch (err) {
    const { statusCode } = err.response.data
    if (statusCode === 403 || statusCode === 404) {
      yield put({ type: error403, payload: true })
    }
    yield put({
      type: Actions.deleteAssocSkillItem.FAILURE,
      err
    })
  } finally {
    yield put({ type: pageIsLoading, payload: false })
  }
}
